import './add_Company.css'
import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import { FormControlLabel, Switch } from '@mui/material';
import Display_Country_States from './Display_Country_States';

const label = { inputProps: { 'aria-label': 'Switch demo' } };

const Add_Company = (props) => {
    let defaulImage = "../images/company.png"
    const [active, setActive] = useState(true)
    const [companyName, setCompanyName] = useState("")
    const [companyLogoUrl, setCompanyLogoUrl] = useState("")

    const [companyType, setCompanyType] = useState("")
    const [companyInformation, setCompanyInformation] = useState("")
    const [companyAddress, setCompanyAddress] = useState("")
    const [companyCity, setCompanyCity] = useState("")
    const [companyState, setCompanyState] = useState("")
    const [companyPINcode, setCompanyPINcode] = useState("")
    const [companyCountry, setCompanyCountry] = useState("India")
    const [companyRegistrationNumber, setCompanyRegistrationNumber] = useState("")
    const [companyRegistrationDocumentUrl, setCompanyRegistrationDocumentUrl] = useState("")
    const [taxNumber, setTaxNumber] = useState("")
    const [taxRegistrationDocumentUrl, setTaxRegistrationDocumentUrl] = useState("")
    const [approverId, setApproverId] = useState("")
    const [approverMobile, setApproverMobile] = useState("")

    const [approverDesignation, setApproverDesignation] = useState("")
    const [spocId, setSpocId] = useState("")
    const [spocMobile, setSpocMobile] = useState("")

    const [spocDesignation, setSpocDesignation] = useState("")
    const [personsData, setPersonsData] = useState([])

    const handleError = (event) => {
        event.target.companyLogoUrl = defaulImage;
    };

    useEffect(() => {
        getPersons()
    }, [props])

    // console.log(props)

    useEffect(() => {
        if (props.display === "Edit") {
            setActive(props.data ? props.data.active : "")
            setCompanyName(props.data ? props.data.companyName : "")
            setCompanyLogoUrl(props.data ? props.data.companyLogoUrl : "")
            setCompanyType(props.data ? props.data.companyType : "")
            setCompanyInformation(props.data ? props.data.companyInformation : "")
            setCompanyAddress(props.data ? props.data.companyAddress : "")
            setCompanyCity(props.data ? props.data.companyCity : "")
            setCompanyState(props.data ? props.data.companyState : "")
            setCompanyPINcode(props.data ? props.data.companyPINcode : "")
            setCompanyCountry(props.data ? props.data.companyCountry : "")
            setCompanyRegistrationNumber(props.data ? props.data.companyRegistrationNumber : "")
            setTaxNumber(props.data ? props.data.taxNumber : "")
            setApproverId(props.data ? props.data.approverId : "")
            setApproverDesignation(props.data ? props.data.approverDesignation : "")
            setSpocId(props.data ? props.data.spocId : "")
            setSpocDesignation(props.data ? props.data.spocDesignation : "")

        }
    }, [props.data, props.display])

    const getPersons = () => {

        let apiURL = process.env.REACT_APP_API_KEY + "/persons";
        let apiParams = {
            method: "GET",
            // headers: {
            //     authtoken: await AsyncStorage.getItem("loggedintoken")

            // },
        };
        fetch(apiURL, apiParams)
            .then((res) => (res.status === 200 ? res.json() : res.text()))
            .then((repos) => {
                if (repos.data) {

                    setPersonsData(repos.data)
                } else alert(repos.message || repos);
            })
            .catch((err) => alert(err));
    }

    const addCompany = () => {
        // if (email.length === 0) {
        //     return alert("Please Enter Email!!");
        // }

        const apiUrl = process.env.REACT_APP_API_KEY + '/companies';
        var apiParam = {
            method: 'POST',
            headers: {
                companyname: companyName,
                companylogourl: companyLogoUrl,
                companytype: companyType,
                companyinformation: companyInformation,
                companyaddress: companyAddress,
                companycity: companyCity,
                companystate: companyState,
                companypincode: companyPINcode,
                companycountry: companyCountry,
                companyRegistrationNumber: companyRegistrationNumber,
                companyregistrationdocumentUrl: companyRegistrationDocumentUrl,
                taxnumber: taxNumber,
                taxregistrationdocumentUrl: taxRegistrationDocumentUrl,
                approverid: approverId,
                approverdesignation: approverDesignation,
                spocid: spocId,
                spocdesignation: spocDesignation,
                active: active,
            },
        };

        // console.log(apiUrl, apiParam, 'apiUrl', 'apiParam')

        fetch(apiUrl, apiParam)
            .then((res) => (res.status === 200 ? res.json() : res.text()))
            .then((repos) => {

                if (repos.data) {

                    alert("Company Added Successfully!!")

                } else alert(JSON.stringify('error'));
            })
            .catch((err) => alert(JSON.stringify(err)));
    };
    const editCompany = (id) => {
        // if (email.length === 0) {
        //     return alert("Please Enter Email!!");
        // }

        const apiUrl = process.env.REACT_APP_API_KEY + '/companies/' + id;
        var apiParam = {
            method: 'POST',
            headers: {
                companyname: companyName,
                companylogourl: companyLogoUrl,
                companytype: companyType,
                companyinformation: companyInformation,
                companyaddress: companyAddress,
                companycity: companyCity,
                companystate: companyState,
                companypincode: companyPINcode,
                companycountry: companyCountry,
                companyRegistrationNumber: companyRegistrationNumber,
                companyregistrationdocumentUrl: companyRegistrationDocumentUrl,
                taxnumber: taxNumber,
                taxregistrationdocumentUrl: taxRegistrationDocumentUrl,
                approverid: approverId,
                approverdesignation: approverDesignation,
                spocid: spocId,
                spocdesignation: spocDesignation,
                active: active,
            },
        };

        // console.log(apiUrl, apiParam, 'apiUrl', 'apiParam')

        fetch(apiUrl, apiParam)
            .then((res) => (res.status === 200 ? res.json() : res.text()))
            .then((repos) => {

                if (repos.data) {

                    alert("Company Edited Successfully!!")

                } else alert(JSON.stringify('error'));
            })
            .catch((err) => alert(JSON.stringify(err)));
    };

    return (
        <>
            <Modal
                open={props.display !== 'none'}
                onClose={() => props.closeAddCompany(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div class='modal-add-company-1'>
                    <div class='add-Company-1'>
                        <div class='add-Company-header-1'>
                            <button class='add-Company-close-btn-1' onClick={() => props.closeAddCompany(false)}>
                                <img id="add-Company-close-img-1" src="../images/close2.png" srcset="../images/close2.png 1x" />
                            </button>
                            <div class='add-Company-name-11'>

                                <img id="add-Company-profile-img-1" src={companyLogoUrl || "../images/company.png"} />

                            </div>

                        </div>
                        <div class='swicth-active-1'>
                            {/* <Switch
                                checked={active}
                                onChange={() => setActive(!active)}
                                inputProps={{ 'aria-label': 'controlled' }}
                                // {...label}
                                defaultChecked /> */}
                            <FormControlLabel control={<Switch
                                checked={active}
                                onChange={() => setActive(!active)}
                                inputProps={{ 'aria-label': 'controlled' }}
                                defaultChecked />} label="Active" />

                        </div>
                        <div class='inputs-add-Company-group'>
                            <div class='Company-names-1'>
                                <div id="Company-name-header-1">
                                    <span>Company Name</span>
                                </div>
                                <input class='add-company-name-input-1' placeholder='Company Name' value={companyName} onChange={(e) => setCompanyName(e.target.value)} />
                            </div>
                            <div class='Company-names-15'>
                                <div id="Company-name-header-15">
                                    <span>Company Type </span>
                                </div>
                                <select class="add-company-name-input-15" value={companyType} onChange={(e) => setCompanyType(e.target.value)}>

                                    <option label="Proprietorship" value="Proprietorship" />
                                    <option label="Partnership" value="Partnership " />
                                    <option label="LLP" value="LLP" />
                                    <option label="Government" value="Government" />
                                    <option label="Other " value="Other" />
                                    <option label="Private Limited" value="Private Limited " />
                                    <option label="Public Limited" value="Public Limited " />
                                </select>
                            </div>
                            <div class='Company-names-2'>
                                <div id="Company-name-header-2">
                                    <span>Company Information </span>
                                </div>
                                <textarea class='add-company-name-input-2' placeholder='Company Information ' value={companyInformation} onChange={(e) => setCompanyInformation(e.target.value)} />
                            </div>
                            <div class='Company-names-1'>
                                <div id="Company-name-header-1">
                                    <span>Company Logo URL</span>
                                </div>
                                <input class='add-company-name-input-1' placeholder='Company Logo URL' value={companyLogoUrl} onChange={(e) => setCompanyLogoUrl(e.target.value)} />
                            </div>
                            <div class='Company-names-16'>
                                <div id="Company-name-header-16">
                                    <span>Company Registration Number</span>
                                </div>
                                <div class='add-compnay-input-uplod-showdoc-group-1'>
                                    <input class='add-company-name-input-16' placeholder='Company Registration Number' value={companyRegistrationNumber} onChange={(e) => setCompanyRegistrationNumber(e.target.value)} />
                                    <img id="add-Company-show-doc-img-1" src="../images/eye-open.png" srcset="../images/eye-open.png 1x" />

                                    <img id="add-Company-upload-img-1" src="../images/file.png" srcset="../images/file.png 1x" />

                                </div>
                            </div>
                            <div class='Company-names-3'>
                                <div id="Company-name-header-3">
                                    <span>GST No.</span>
                                </div>

                                <div class='add-compnay-input-uplod-showdoc-group-3'>
                                    <input class='add-company-name-input-3' placeholder='GST No.' value={taxNumber} onChange={(e) => setTaxNumber(e.target.value)} />
                                    <img id="add-Company-show-doc-img-3" src="../images/eye-open.png" srcset="../images/eye-open.png 1x" />

                                    <img id="add-Company-upload-img-3" src="../images/file.png" srcset="../images/file.png 1x" />

                                </div>
                            </div>
                            <div class='Company-names-4'>
                                <div id="Company-name-header-4">
                                    <span>Address</span>
                                </div>
                                <textarea class='add-company-name-input-4' placeholder='Address' value={companyAddress} onChange={(e) => setCompanyAddress(e.target.value)} />
                            </div>
                            <div class='add-company-state-country-group-1'>
                                <div class='Company-names-5'>
                                    <div id="Company-name-header-5">
                                        <span>Country </span>
                                    </div>
                                    <select class="add-company-name-input-5" value={companyCountry} onChange={(e) => setCompanyCountry(e.target.value)}>

                                        <option value="Afghanistan">Afghanistan</option>
                                        <option value="Åland Islands">Åland Islands</option>
                                        <option value="Albania">Albania</option>
                                        <option value="Algeria">Algeria</option>
                                        <option value="American Samoa">American Samoa</option>
                                        <option value="Andorra">Andorra</option>
                                        <option value="Angola">Angola</option>
                                        <option value="Anguilla">Anguilla</option>
                                        <option value="Antarctica">Antarctica</option>
                                        <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                        <option value="Argentina">Argentina</option>
                                        <option value="Armenia">Armenia</option>
                                        <option value="Aruba">Aruba</option>
                                        <option value="Australia">Australia</option>
                                        <option value="Austria">Austria</option>
                                        <option value="Azerbaijan">Azerbaijan</option>
                                        <option value="Bahamas">Bahamas</option>
                                        <option value="Bahrain">Bahrain</option>
                                        <option value="Bangladesh">Bangladesh</option>
                                        <option value="Barbados">Barbados</option>
                                        <option value="Belarus">Belarus</option>
                                        <option value="Belgium">Belgium</option>
                                        <option value="Belize">Belize</option>
                                        <option value="Benin">Benin</option>
                                        <option value="Bermuda">Bermuda</option>
                                        <option value="Bhutan">Bhutan</option>
                                        <option value="Bolivia">Bolivia</option>
                                        <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                        <option value="Botswana">Botswana</option>
                                        <option value="Bouvet Island">Bouvet Island</option>
                                        <option value="Brazil">Brazil</option>
                                        <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                                        <option value="Brunei Darussalam">Brunei Darussalam</option>
                                        <option value="Bulgaria">Bulgaria</option>
                                        <option value="Burkina Faso">Burkina Faso</option>
                                        <option value="Burundi">Burundi</option>
                                        <option value="Cambodia">Cambodia</option>
                                        <option value="Cameroon">Cameroon</option>
                                        <option value="Canada">Canada</option>
                                        <option value="Cape Verde">Cape Verde</option>
                                        <option value="Cayman Islands">Cayman Islands</option>
                                        <option value="Central African Republic">Central African Republic</option>
                                        <option value="Chad">Chad</option>
                                        <option value="Chile">Chile</option>
                                        <option value="China">China</option>
                                        <option value="Christmas Island">Christmas Island</option>
                                        <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                                        <option value="Colombia">Colombia</option>
                                        <option value="Comoros">Comoros</option>
                                        <option value="Congo">Congo</option>
                                        <option value="Congo, The Democratic Republic of The">Congo, The Democratic Republic of The</option>
                                        <option value="Cook Islands">Cook Islands</option>
                                        <option value="Costa Rica">Costa Ri
                                            ca</option>
                                        <option value="Cote D'ivoire">Cote D'ivoire</option>
                                        <option value="Croatia">Croatia</option>
                                        <option value="Cyprus">Cyprus</option>
                                        <option value="Czech Republic">Czech Republic</option>
                                        <option value="Denmark">Denmark</option>
                                        <option value="Djibouti">Djibouti</option>
                                        <option value="Dominica">Dominica</option>
                                        <option value="Dominican Republic">Dominican Republic</option>
                                        <option value="Ecuador">Ecuador</option>
                                        <option value="Egypt">Egypt</option>
                                        <option value="El Salvador">El Salvador</option>
                                        <option value="Equatorial Guinea">Equatorial Guinea</option>
                                        <option value="Eritrea">Eritrea</option>
                                        <option value="Estonia">Estonia</option>
                                        <option value="Ethiopia">Ethiopia</option>
                                        <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                                        <option value="Faroe Islands">Faroe Islands</option>
                                        <option value="Fiji">Fiji</option>
                                        <option value="Finland">Finland</option>
                                        <option value="France">France</option>
                                        <option value="French Guiana">French Guiana</option>
                                        <option value="French Polynesia">French Polynesia</option>
                                        <option value="French Southern Territories">French Southern Territories</option>
                                        <option value="Gabon">Gabon</option>
                                        <option value="Gambia">Gambia</option>
                                        <option value="Georgia">Georgia</option>
                                        <option value="Germany">Germany</option>
                                        <option value="Ghana">Ghana</option>
                                        <option value="Gibraltar">Gibraltar</option>
                                        <option value="Greece">Greece</option>
                                        <option value="Greenland">Greenland</option>
                                        <option value="Grenada">Grenada</option>
                                        <option value="Guadeloupe">Guadeloupe</option>
                                        <option value="Guam">Guam</option>
                                        <option value="Guatemala">Guatemala</option>
                                        <option value="Guernsey">Guernsey</option>
                                        <option value="Guinea">Guinea</option>
                                        <option value="Guinea-bissau">Guinea-bissau</option>
                                        <option value="Guyana">Guyana</option>
                                        <option value="Haiti">Haiti</option>
                                        <option value="Heard Island and Mcdonald Islands">Heard Island and Mcdonald Islands</option>
                                        <option value="Holy See (Vatican City State)">Holy See (Vatican City State)</option>
                                        <option value="Honduras">Honduras</option>
                                        <option value="Hong Kong">Hong Kong</option>
                                        <option value="Hungary">Hungary</option>
                                        <option value="Iceland">Iceland</option>
                                        <option value="India">India</option>
                                        <option value="Indonesia">Indonesia</option>
                                        <option value="Iran, Islamic Republic of">Iran, Islamic Republic of</option>
                                        <option value="Iraq">Iraq</option>
                                        <option value="Ireland">Ireland</option>
                                        <option value="Isle of Man">Isle of Man</option>
                                        <option value="Israel">Israel</option>
                                        <option value="Italy">Italy</option>
                                        <option value="Jamaica">Jamaica</option>
                                        <option value="Japan">Japan</option>
                                        <option value="Jersey">Jersey</option>
                                        <option value="Jordan">Jordan</option>
                                        <option value="Kazakhstan">Kazakhstan</option>
                                        <option value="Kenya">Kenya</option>
                                        <option value="Kiribati">Kiribati</option>
                                        <option value="Korea, Democratic People's Republic of">Korea, Democratic People's Republic of</option>
                                        <option value="Korea, Republic of">Korea, Republic of</option>
                                        <option value="Kuwait">Kuwait</option>
                                        <option value="Kyrgyzstan">Kyrgyzstan</option>
                                        <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                                        <option value="Latvia">Latvia</option>
                                        <option value="Lebanon">Lebanon</option>
                                        <option value="Lesotho">Lesotho</option>
                                        <option value="Liberia">Liberia</option>
                                        <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                                        <option value="Liechtenstein">Liechtenstein</option>
                                        <option value="Lithuania">Lithuania</option>
                                        <option value="Luxembourg">Luxembourg</option>
                                        <option value="Macao">Macao</option>
                                        <option value="Macedonia, The Former Yugoslav Republic of">Macedonia, The Former Yugoslav Republic of</option>
                                        <option value="Madagascar">Madagascar</option>
                                        <option value="Malawi">Malawi</option>
                                        <option value="Malaysia">Malaysia</option>
                                        <option value="Maldives">Maldives</option>
                                        <option value="Mali">Mali</option>
                                        <option value="Malta">Malta</option>
                                        <option value="Marshall Islands">Marshall Islands</option>
                                        <option value="Martinique">Martinique</option>
                                        <option value="Mauritania">Mauritania</option>
                                        <option value="Mauritius">Mauritius</option>
                                        <option value="Mayotte">Mayotte</option>
                                        <option value="Mexico">Mexico</option>
                                        <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                                        <option value="Moldova, Republic of">Moldova, Republic of</option>
                                        <option value="Monaco">Monaco</option>
                                        <option value="Mongolia">Mongolia</option>
                                        <option value="Montenegro">Montenegro</option>
                                        <option value="Montserrat">Montserrat</option>
                                        <option value="Morocco">Morocco</option>
                                        <option value="Mozambique">Mozambique</option>
                                        <option value="Myanmar">Myanmar</option>
                                        <option value="Namibia">Namibia</option>
                                        <option value="Nauru">Nauru</option>
                                        <option value="Nepal">Nepal</option>
                                        <option value="Netherlands">Netherlands</option>
                                        <option value="Netherlands Antilles">Netherlands Antilles</option>
                                        <option value="New Caledonia">New Caledonia</option>
                                        <option value="New Zealand">New Zealand</option>
                                        <option value="Nicaragua">Nicaragua</option>
                                        <option value="Niger">Niger</option>
                                        <option value="Nigeria">Nigeria</option>
                                        <option value="Niue">Niue</option>
                                        <option value="Norfolk Island">Norfolk Island</option>
                                        <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                        <option value="Norway">Norway</option>
                                        <option value="Oman">Oman</option>
                                        <option value="Pakistan">Pakistan</option>
                                        <option value="Palau">Palau</option>
                                        <option value="Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                                        <option value="Panama">Panama</option>
                                        <option value="Papua New Guinea">Papua New Guinea</option>
                                        <option value="Paraguay">Paraguay</option>
                                        <option value="Peru">Peru</option>
                                        <option value="Philippines">Philippines</option>
                                        <option value="Pitcairn">Pitcairn</option>
                                        <option value="Poland">Poland</option>
                                        <option value="Portugal">Portugal</option>
                                        <option value="Puerto Rico">Puerto Rico</option>
                                        <option value="Qatar">Qatar</option>
                                        <option value="Reunion">Reunion</option>
                                        <option value="Romania">Romania</option>
                                        <option value="Russian Federation">Russian Federation</option>
                                        <option value="Rwanda">Rwanda</option>
                                        <option value="Saint Helena">Saint Helena</option>
                                        <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                        <option value="Saint Lucia">Saint Lucia</option>
                                        <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                                        <option value="Saint Vincent and The Grenadines">Saint Vincent and The Grenadines</option>
                                        <option value="Samoa">Samoa</option>
                                        <option value="San Marino">San Marino</option>
                                        <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                                        <option value="Saudi Arabia">Saudi Arabia</option>
                                        <option value="Senegal">Senegal</option>
                                        <option value="Serbia">Serbia</option>
                                        <option value="Seychelles">Seychelles</option>
                                        <option value="Sierra Leone">Sierra Leone</option>
                                        <option value="Singapore">Singapore</option>
                                        <option value="Slovakia">Slovakia</option>
                                        <option value="Slovenia">Slovenia</option>
                                        <option value="Solomon Islands">Solomon Islands</option>
                                        <option value="Somalia">Somalia</option>
                                        <option value="South Africa">South Africa</option>
                                        <option value="South Georgia and The South Sandwich Islands">South Georgia and The South Sandwich Islands</option>
                                        <option value="Spain">Spain</option>
                                        <option value="Sri Lanka">Sri Lanka</option>
                                        <option value="Sudan">Sudan</option>
                                        <option value="Suriname">Suriname</option>
                                        <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                                        <option value="Swaziland">Swaziland</option>
                                        <option value="Sweden">Sweden</option>
                                        <option value="Switzerland">Switzerland</option>
                                        <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                                        <option value="Taiwan">Taiwan</option>
                                        <option value="Tajikistan">Tajikistan</option>
                                        <option value="Tanzania, United Republic of">Tanzania, United Republic of</option>
                                        <option value="Thailand">Thailand</option>
                                        <option value="Timor-leste">Timor-leste</option>
                                        <option value="Togo">Togo</option>
                                        <option value="Tokelau">Tokelau</option>
                                        <option value="Tonga">Tonga</option>
                                        <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                                        <option value="Tunisia">Tunisia</option>
                                        <option value="Turkey">Turkey</option>
                                        <option value="Turkmenistan">Turkmenistan</option>
                                        <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                                        <option value="Tuvalu">Tuvalu</option>
                                        <option value="Uganda">Uganda</option>
                                        <option value="Ukraine">Ukraine</option>
                                        <option value="United Arab Emirates">United Arab Emirates</option>
                                        <option value="United Kingdom">United Kingdom</option>
                                        <option value="United States">United States</option>
                                        <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                                        <option value="Uruguay">Uruguay</option>
                                        <option value="Uzbekistan">Uzbekistan</option>
                                        <option value="Vanuatu">Vanuatu</option>
                                        <option value="Venezuela">Venezuela</option>
                                        <option value="Viet Nam">Viet Nam</option>
                                        <option value="Virgin Islands, British">Virgin Islands, British</option>
                                        <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
                                        <option value="Wallis and Futuna">Wallis and Futuna</option>
                                        <option value="Western Sahara">Western Sahara</option>
                                        <option value="Yemen">Yemen</option>
                                        <option value="Zambia">Zambia</option>
                                        <option value="Zimbabwe">Zimbabwe</option>

                                    </select>
                                </div>
                                <div class='Company-names-6'>
                                    <div id="Company-name-header-6">
                                        <span>State</span>
                                    </div>
                                    {/* <select class="add-company-name-input-6" value={companyState} onChange={(e) => setCompanyState(e.target.value)}>
                                        <option value="AP">Andhra Pradesh</option>
                                        <option value="AR">Arunachal Pradesh</option>
                                        <option value="AS">Assam</option>
                                        <option value="BR">Bihar</option>
                                        <option value="CT">Chhattisgarh</option>
                                        <option value="GA">Gujarat</option>
                                        <option value="HR">Haryana</option>
                                        <option value="HP">Himachal Pradesh</option>
                                        <option value="JK">Jammu and Kashmir</option>
                                        <option value="GA">Goa</option>
                                        <option value="JH">Jharkhand</option>
                                        <option value="KA">Karnataka</option>
                                        <option value="KL">Kerala</option>
                                        <option value="MP">Madhya Pradesh</option>
                                        <option value="MH">Maharashtra</option>
                                        <option value="MN">Manipur</option>
                                        <option value="ML">Meghalaya</option>
                                        <option value="MZ">Mizoram</option>
                                        <option value="NL">Nagaland</option>
                                        <option value="OR">Odisha</option>
                                        <option value="PB">Punjab</option>
                                        <option value="RJ">Rajasthan</option>
                                        <option value="SK">Sikkim</option>
                                        <option value="TN">Tamil Nadu</option>
                                        <option value="TG">Telangana</option>
                                        <option value="TR">Tripura</option>
                                        <option value="UT">Uttarakhand</option>
                                        <option value="UP">Uttar Pradesh</option>
                                        <option value="WB">West Bengal</option>
                                        <option value="AN">Andaman and Nicobar Islands</option>
                                        <option value="CH">Chandigarh</option>
                                        <option value="DN">Dadra and Nagar Haveli</option>
                                        <option value="DD">Daman and Diu</option>
                                        <option value="DL">Delhi</option>
                                        <option value="LD">Lakshadweep</option>
                                        <option value="PY">Puducherry</option>


                                    </select> */}

                                    <Display_Country_States country={companyCountry} companyState={companyState} setCompanyState={(newText) => setCompanyState(newText)} />
                                </div>
                            </div>
                            <div class='add-company-state-country-group-2'>
                                <div class='Company-names-7'>
                                    <div id="Company-name-header-7">
                                        <span>City/Town </span>
                                    </div>
                                    <input class='add-company-name-input-7' placeholder='City/Town' value={companyCity} onChange={(e) => setCompanyCity(e.target.value)} />

                                </div>
                                <div class='Company-names-8'>
                                    <div id="Company-name-header-8">
                                        <span>PIN</span>
                                    </div>
                                    <input class='add-company-name-input-8' placeholder='Pin.' value={companyPINcode} onChange={(e) => setCompanyPINcode(e.target.value)} />

                                </div>
                            </div>
                            <div class='Company-names-9'>
                                <div id="Company-name-header-9">
                                    <span>Contact Person Name</span>
                                </div>
                                <select class="add-company-name-input-9" value={spocId} onChange={(e) => setSpocId(e.target.value)} >
                                    <option label="Select" value="0" />

                                    {personsData.map((rew) =>
                                        <option label={rew.name} value={rew._id} />
                                    )}
                                </select>
                            </div>
                            <div class='Company-names-10'>
                                <div id="Company-name-header-10">
                                    <span>Contact Person Mobile</span>
                                </div>
                                <select class="add-company-name-input-10" value={spocMobile} onChange={(e) => setSpocMobile(e.target.value)} >

                                    {personsData.filter(re => re._id === spocId).map((rew) =>
                                        <option label={rew.mobile} value={rew.mobile} />
                                    )}
                                </select>
                            </div>
                            <div class='Company-names-11'>
                                <div id="Company-name-header-11">
                                    <span>Contact Person Designation</span>
                                </div>
                                <input class='add-company-name-input-11' placeholder='Contact Person Designation' value={spocDesignation} onChange={(e) => setSpocDesignation(e.target.value)} />
                            </div>
                            <div class='Company-names-12'>
                                <div id="Company-name-header-12">
                                    <span>Accounts Person Name</span>
                                </div>
                                {/* <input class='add-company-name-input-12' placeholder='Accounts Person Name' value={approverId} onChange={(e) => setApproverId(e.target.value)} /> */}
                                <select class="add-company-name-input-12" value={approverId} onChange={(e) => setApproverId(e.target.value)} >
                                    <option label="Select" value="0" />

                                    {personsData.map((rew) =>
                                        <option label={rew.name} value={rew._id} />
                                    )}
                                </select>
                            </div>
                            <div class='Company-names-13'>
                                <div id="Company-name-header-13">
                                    <span>Accounts Person Mobile</span>
                                </div>
                                {/* <input class='add-company-name-input-13' placeholder='Accounts Person Mobile' value={approverMobile} onChange={(e) => setApproverMobile(e.target.value)} /> */}
                                <select class="add-company-name-input-13" value={approverMobile} onChange={(e) => setApproverMobile(e.target.value)} >

                                    {personsData.filter(re => re._id === approverId).map((rew) =>
                                        <option label={rew.mobile} value={rew.mobile} />
                                    )}
                                </select>
                            </div>
                            <div class='Company-names-14'>
                                <div id="Company-name-header-14">
                                    <span>Accounts Person Designation</span>
                                </div>
                                <input class='add-company-name-input-14' placeholder='Accounts Person Designation' value={approverDesignation} onChange={(e) => setApproverDesignation(e.target.value)} />
                            </div>

                        </div>
                        <button class='add-btn-Company-1' onClick={() => props.display === "Edit" ? editCompany(props.data._id) : addCompany()}>
                            {props.display}
                        </button>
                    </div>
                    {/* <Button onClick={() => props.closeAddSoftware(false)}>Close</Button> */}
                </div>

            </Modal>
        </>
    )
}
export default Add_Company